export * from './translatedText.en';
export * from './translatedText.pl';
